import _toConsumableArray from "/Users/challen/code/element-tracker/example/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { Children, isValidElement } from 'react';

var groupByType = function groupByType(children) {
  var types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var rest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'rest';
  return Children.toArray(children).reduce(function (groups, child) {
    var newGroups = Object.assign({}, groups);
    var key = rest;

    if (isValidElement(child) && typeof child.type === 'string' && types.includes(child.type)) {
      key = child.type;
    }

    if (typeof newGroups[key] === 'undefined') {
      newGroups[key] = [];
    }

    newGroups[key] = [].concat(_toConsumableArray(newGroups[key]), [child]);
    return newGroups;
  }, {});
};

export default groupByType;